import always from 'ramda/es/always';
import evolve from 'ramda/es/evolve';
import omit from 'ramda/es/omit';
import assoc from 'ramda/es/assoc';

import {
  STUDENTS_FILTER_REQUEST,
  STUDENTS_FILTER_SUCCESS,
  STUDENTS_FILTER_FAILURE,
  STUDENTS_FILTER_CLEAR,
  STUDENTS_FILTER_DELETE,
  STUDENTS_FILTER_SET,
  STUDENTS_FILTER_UPDATE,
} from 'app/actions/reports/filters/students';


const defaultState = {
  data: {},
  selected: {},
  loading: true,
  active: false,
};

const students = (state = defaultState, { type, payload }) => {
  switch (type) {
    case STUDENTS_FILTER_REQUEST: {
      return { ...state, loading: true };
    }
    case STUDENTS_FILTER_SUCCESS: {
      return evolve({
        data: always(payload),
        loading: always(false),
      }, state);
    }
    case STUDENTS_FILTER_FAILURE: {
      return { ...state, loading: false };
    }
    case STUDENTS_FILTER_CLEAR: {
      return defaultState;
    }
    case STUDENTS_FILTER_DELETE: {
      return evolve({ selected: omit(payload) }, state);
    }
    case STUDENTS_FILTER_SET: {
      return assoc('selected', payload, state);
    }
    case STUDENTS_FILTER_UPDATE: {
      return { ...state, ...payload };
    }
    default:
  }
  return state;
};

export default students;
